import { computed, DestroyRef, inject, input, signal } from '@angular/core';
import { ImageModule } from 'Angular/features/directives/image/image.module';
import * as i0 from "@angular/core";
import * as i1 from "Angular/features/directives/image/image.directive";
export class AgentLoaderComponent {
    constructor() {
        this.currentLoadingText = input('', ...(ngDevMode ? [{ debugName: "currentLoadingText" }] : []));
        // replace the ... that comes from our messages and animate our own
        this.loadingLabel = computed(() => this.currentLoadingText().replace(/\.{3}$/, ''), ...(ngDevMode ? [{ debugName: "loadingLabel" }] : []));
        this.elapsedSeconds = signal(0, ...(ngDevMode ? [{ debugName: "elapsedSeconds" }] : []));
        this._startedAt = Date.now();
        const intervalId = window.setInterval(() => {
            this.elapsedSeconds.set(Math.round((Date.now() - this._startedAt) / 1000));
        }, 1000);
        inject(DestroyRef).onDestroy(() => window.clearInterval(intervalId));
    }
}
AgentLoaderComponent.ɵfac = function AgentLoaderComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AgentLoaderComponent)(); };
AgentLoaderComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AgentLoaderComponent, selectors: [["ycn-agent-loader"]], inputs: { currentLoadingText: [1, "currentLoadingText"] }, decls: 8, vars: 3, consts: [[1, "ai-thinking", "d-flex", "align-items-center"], [1, "ai-thinking-mark", "flex-none", "mr-1"], [1, "circle-progress", "circle-progress-lg", "circle-progress-halfmoon"], ["ycnImage", "", "alt", "", 1, "width-24", "height-24", 3, "imageSrc"], [1, "text-large"], [1, "ellipsis", "d-inline-block", "width-13"]], template: function AgentLoaderComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        i0.ɵɵelement(2, "div", 2)(3, "img", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 4);
        i0.ɵɵtext(5);
        i0.ɵɵelement(6, "span", 5);
        i0.ɵɵtext(7);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("imageSrc", "images/core/ycharts-logo-ai-circle.svg");
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.loadingLabel());
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" (", ctx.elapsedSeconds(), "s)");
    } }, dependencies: [ImageModule, i1.ImageDirective], encapsulation: 2, changeDetection: 0 });
